module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.stats) ? _c('div', [_vm._m(0), _c('br'), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card",
      "tab-position": "top"
    }
  }, [(_vm.isProjectView()) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-broadcast-tower"
  }), _vm._v(" Project Summary")]), _vm._v(" "), _c('project-summary')], 1) : _vm._e(), _vm._v(" "), (_vm.isMaintView()) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-headset"
  }), _vm._v(" Tickets")]), _vm._v(" "), _c('maintenance-summary')], 1) : _vm._e(), _vm._v(" "), (_vm.isMaintView()) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa fa-list"
  }), _vm._v(" Site Workflow")]), _vm._v(" "), _c('site-workflow')], 1) : _vm._e(), _vm._v(" "), (_vm.isPropertyView()) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" Property Summary")]), _vm._v(" "), _c('property-summary')], 1) : _vm._e(), _vm._v(" "), (_vm.isPropertyView()) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-calendar-day"
  }), _vm._v(" Expiry")]), _vm._v(" "), _c('expiry-table')], 1) : _vm._e(), _vm._v(" "), (_vm.isPropertyView()) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-asterisk"
  }), _vm._v(" Tenancy Due")]), _vm._v(" "), _c('tenancy-due')], 1) : _vm._e(), _vm._v(" "), (_vm.isPropertyView()) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-calendar-week"
  }), _vm._v(" Rental by Month")]), _vm._v(" "), _c('property-rental-month')], 1) : _vm._e(), _vm._v(" "), (_vm.isFinanceView()) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-money-alt"
  }), _vm._v(" Finance Summary")]), _vm._v(" "), _c('finance-summary')], 1) : _vm._e(), _vm._v(" "), (_vm.isFinanceView()) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-dollar-sign"
  }, [_vm._v(" ")]), _vm._v("Invoicing")]), _vm._v(" "), _c('invoicing-view')], 1) : _vm._e(), _vm._v(" "), (_vm.isAdminView()) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-chart-pie"
  }), _vm._v(" Sites & Operations")]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Sites")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 14,
      "md": 16,
      "lg": 12
    }
  }, [_c('sites-chart', {
    attrs: {
      "show-legend": false,
      "stats": _vm.stats
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 10,
      "md": 8,
      "lg": 8
    }
  }, [_c('sites-stats-table')], 1)], 1), _vm._v(" "), (_vm.canAccess('project|maintenance|admin|management') && _vm.stats.actions && _vm.stats.tickets && !_vm.isProjectView()) ? _c('div', [_c('el-row', [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Operations")])]), _vm._v(" "), (_vm.canAccess('project|maintenance|admin') && (_vm.stats.actions || _vm.stats.tickets)) ? _c('el-row', [_c('op-stats', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && _vm.canAccess('management|project|maintenance|finance|admin')) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Sharer Summary")]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Sharers")])]), _vm._v(" "), _c('sharer-report', {
    attrs: {
      "show-ways": true
    }
  }), _vm._v(" "), _c('sharing-summary-report', {
    attrs: {
      "title-class": "dash-heading",
      "hide-org-badge": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && _vm.canAccess('project|finance|maintenance|admin')) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Request Files")]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Requests Files")])]), _vm._v(" "), _c('files-request-table')], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && _vm.isAdminView() && _vm.canAccess('finance|admin')) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-plug"
  }, [_vm._v(" ")]), _vm._v(_vm._s(_vm.utilLabel + ' Bills'))]), _vm._v(" "), _c('utilities-table')], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && _vm.canAccess('maintenance|finance|management|admin')) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }, [_vm._v(" ")]), _vm._v("Calendar")]), _vm._v(" "), _c('div', {
    staticClass: "padded"
  }, [_c('events-calendar')], 1)]) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-heading"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Management Summary")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3381c29a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/views/SummaryDashboard.vue
// module id = 1484
// module chunks = 0